import { toHijri, toGregorian } from "@libs/hijri-converter";

/**
 * A simplified Hijri date conversion service
 * Note: This is for demonstration purposes only.
 * In a real implementation, use a proper Hijri conversion library
 */

export var AdhanService = {
  GregorianToHijri: function GregorianToHijri(date) {
    if (!date || isNaN(date.getTime())) return null;
    // Create a key in the format YYYY-M-D
    var year = date.getFullYear();
    var month = date.getMonth();
    var day = date.getDate();
    var hijriDate = toHijri(year, month, day);
    return {
      day: hijriDate.hd,
      month: hijriDate.hm,
      year: hijriDate.hy
    };
  },
  HijriToGregorian: function HijriToGregorian(year, month, day) {
    if (year === null || month === null || day === null || isNaN(year) || isNaN(month) || isNaN(day)) {
      return null;
    }
    var gDate = toGregorian(year, month, day);
    return new Date(gDate.gy, gDate.gm, gDate.gd);
  }
};